import React from 'react'
import { useSelector } from 'react-redux'

export const WelcomeScreen = () => {


    const {name } = useSelector(state => state.auth)
  return (
    <div>

            <h1 className='container'>Bienvenido {name}</h1>



    </div>
  )
}
